import { Badge } from '@ibsys/kit';
import { ArrowUpRightIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useConversationLink } from '@/entities/conversations';
import type { StrategistCellDialog } from '@/entities/strategist';
import { isPositiveOutcome } from '../lib/outcome';
import { ReplyRow } from './ReplyRow';

type Props = {
  dialog: StrategistCellDialog;
};

/** Диалог среза: исход и дата в заголовке, ниже — реплики, которыми диалог в срез попал. */
export const DialogRow: FC<Props> = ({ dialog }) => {
  const { t } = useTranslation('strategist');
  const buildLink = useConversationLink();
  const isPositive = isPositiveOutcome(dialog.outcome);
  const replies = dialog.replies.filter((reply) => reply.text.trim() !== '');
  const { to, state } = buildLink(dialog.cid);

  return (
    <div className="flex flex-col gap-2 rounded-xl border border-border bg-card p-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2">
          <Badge variant={isPositive ? 'primary' : 'destructive'} outline>
            {dialog.outcome}
          </Badge>
          {dialog.date && <span className="text-sm text-muted-foreground">{dialog.date}</span>}
        </div>
        <Link
          to={to}
          state={state}
          className="flex shrink-0 items-center gap-1 text-sm text-primary hover:text-primary/80"
        >
          {t('dialogsDrawer.open')}
          <ArrowUpRightIcon className="size-4" />
        </Link>
      </div>
      {replies.length > 0 && (
        <div className="flex flex-col gap-2">
          {replies.map((reply, index) => (
            <ReplyRow key={`${reply.phraseId ?? index}`} conversationId={dialog.cid} reply={reply} />
          ))}
        </div>
      )}
    </div>
  );
};
